import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'PUT_DEVICE_EXTRA',
    method: 'PUT',
    data: param,
  });

  useEffect(() => {
    if (param) {
      let url = `/api/machine/extra`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);
  return { exec, isRequestSuccessed };
});
